import { useState } from 'react';
import { observer } from 'mobx-react';
import { GeneralTasksTab } from '@roc/feature-general-tasks';
import { Tabs } from '@roc/ui';
import { Box } from '@material-ui/core';
import { MyOtherTasksGrid } from './myOtherTasksGrid';
import { MyLoanTasksGridGrouped } from './myLoanTasksGridGrouped';

export const MyTasksGridExternal = observer(({ isFromBackOfficeView = false }) => {

  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  const TABS = [
    {
      value: GeneralTasksTab.MY_LOAN_TASKS_GROUPED,
      label: 'Loan Tasks',
    },
    {
      value: GeneralTasksTab.MY_OTHER_TASKS,
      label: 'Other Tasks',
    },
  ];

  const onTabChange = (e, index) => {
    setSelectedTabIndex(index);
  };

  return (
    <Box pt={2} pb={2}>
      <Tabs
        tabs={TABS}
        selectedTab={selectedTabIndex}
        onTabChange={onTabChange}
        right={
          <>
          </>
        }
      />
      {selectedTabIndex == 0 &&
        <MyLoanTasksGridGrouped isFromBackOfficeView={isFromBackOfficeView} />
      }
      {selectedTabIndex == 1 &&
        <MyOtherTasksGrid isFromBackOfficeView={isFromBackOfficeView} />
      }
    </Box>
  );
});
